import CONST_SUB_GENRE from 'features/SubGenre/constans';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';

import Accordion from 'react-bootstrap/Accordion';

interface FilterProps {
  setName: (name: string) => void;
  handleFilter: () => void;
  setDeleteFlg?: (deleteFlg: number) => void;
  name: string;
  deleteFlg: number;
}

const deleteFlgString: any = {
  '0': '削除データのみ表示',
  '1': '削除データ非表示',
  '-1': '削除データ含めて表示',
};

function Filter({ setName, handleFilter, setDeleteFlg, name, deleteFlg }: FilterProps) {
  const { t } = useTranslation();

  function handleChangeName(event: any) {
    setName(event.target.value);
  }

  function handleChangeDelFlg(event: any) {
    setDeleteFlg && setDeleteFlg(event.target.value);
  }

  return (
    <Form>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('MenuAddModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Row} className="mb-2">
              <Form.Label htmlFor="control-1" column sm={1} md={1} lg={1} xl={1}>
                {t('Genre.Filter.name')}
              </Form.Label>
              <Col sm={3} md={3} lg={3} xl={3}>
                <Form.Control type="text" onChange={handleChangeName} id="control-1" />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-0">
              <Form.Label column sm={1} md={1} lg={1} xl={1}>
                {t('Genre.Filter.delete_date')}
              </Form.Label>
              <Col sm={5} md={5} lg={5} xl={5} className="d-flex align-items-center">
                <Form.Check
                  inline
                  defaultChecked={true}
                  type="radio"
                  label={t('Genre.Filter.hide_del')}
                  id="3"
                  onChange={handleChangeDelFlg}
                  name="delete_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.HIDE_DEL}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('Genre.Filter.show_all_del')}
                  id="4"
                  onChange={handleChangeDelFlg}
                  name="delete_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.ALL}
                />
                <Form.Check
                  inline
                  type="radio"
                  label={t('Genre.Filter.show_del')}
                  id="5"
                  onChange={handleChangeDelFlg}
                  name="delete_flg"
                  value={CONST_SUB_GENRE.CONST_SUB_DEL_GENRE_FILTER.SHOW_DEL}
                />
              </Col>

              <Col sm={6} md={6} lg={6} xl={6} className="d-flex justify-content-end">
                <button type="button" className="btn btn-primary " onClick={handleFilter}>
                  {t('Genre.Button.search')}
                </button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('Genre.Filter.name')}: {name}
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('Genre.Filter.delete_date')}: {deleteFlgString[deleteFlg.toString()]}
                </Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </Form>
  );
}

export default Filter;
